import { defineMessages } from 'react-intl';

export default defineMessages({
  import: 'Import content from another survey',
  helpText: 'Add content to your survey by dragging questions from the sidebar. You can also reorder questions with drag and drop. Questions can be grouped in blocks for better overview or presented to the respondent when certain criteria are met.',
  activeTooltip: 'Disable',
  inactiveTooltip: 'Enable',
  confirmDeleteContent: 'Are you sure you want to delete this content?',
  confirmDeleteQuestion: 'Are you sure you want to this question?',
  confirmDeleteText: 'Are you sure you want to delete this text?',
  confirmDeleteBlock: 'Are you sure you want to delete this block and all questions in the block?',
  delete: 'Delete',
  save: 'Save',
  questionHasResponses: 'This question has {responses} response(s).',
  blockHasQuestionsWithResponses: 'This block contains question(s) with response(s).',
  empty: 'Drag content from the left hand side to add.',

  contentSaveSuccess: 'Survey content saved!',
  contentSaveError: 'Failed to save content. Please try again later.',
});
